import { useEffect, useState } from "react";
import { ChevronUp, Search } from "lucide-react";
import { splitDateTime } from "../../utils/generateDateTime.js";
import "./SessionList.css";
import useUserStore from "../../store/useUserStore.js";
import usePatientStore from "../../store/usePatientStore.js";
import { useNavigate } from "react-router-dom";

// const SessionsList = ({ setIsSelectedPatient }) => {
const SessionsList = () => {
  const navigate = useNavigate()
  const [isExpanded, setIsExpanded] = useState(false);
  const { user, fetchSessions, allSessions,setActivePage } = useUserStore();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredList, setFilteredList] = useState(allSessions);
  const {
    currentSession,
    setCurrentSession,
    setSummary1,
    setSummary3,
    setSummary2,
    setSopnotes,
    setDoctorLetter,
    setSurgicalNote,
    setSurgicalRecording,
    setTranscriptData,
    setAudioUrlData,
    setFinalSummary,
    getConsultationDetail,
    setConsultationId,
    final_summary,
    consultationId,
  } = usePatientStore();

  useEffect(() => {
    if (user) {
      fetchSessions(user?.dentist_id);
    }
  }, [user, final_summary, consultationId]);

  useEffect(() => {
    setFilteredList(allSessions);
  }, [allSessions]);


  const handleSelectSession = async (session,consultation_Id, name,ind) => {
    await setAllDataNull();
    setCurrentSession(session)
    setConsultationId(consultation_Id);
    // setIsSelectedPatient(true);
    navigate("/dashboard/selected-session")
    setActivePage("selected-session")
    await getConsultationDetail(consultation_Id);
    
  };

  const setAllDataNull = async () => {
    setTranscriptData(null);
    setFinalSummary(null);
    setAudioUrlData(null);
    setSummary1(null);
    setSummary2(null);
    setSummary3(null);
    setSopnotes(null);
    setSurgicalNote(null);
    setSurgicalRecording(null)
    setDoctorLetter(null);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);

    if (query === "") {
      setFilteredList(allSessions);
    } else {
      const filtered = allSessions.filter((session) =>
        session.patient_name.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredList(filtered);
    }
  };

  

  return (
    <div className="sessions-container">
      <button
        className="sessions-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="header-content">
          <span className="icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 22.0001C0 19.8783 0.842855 17.8435 2.34315 16.3432C3.84344 14.8429 5.87827 14.0001 8 14.0001C10.1217 14.0001 12.1566 14.8429 13.6569 16.3432C15.1571 17.8435 16 19.8783 16 22.0001H14C14 20.4088 13.3679 18.8826 12.2426 17.7574C11.1174 16.6322 9.5913 16.0001 8 16.0001C6.4087 16.0001 4.88258 16.6322 3.75736 17.7574C2.63214 18.8826 2 20.4088 2 22.0001H0ZM8 13.0001C4.685 13.0001 2 10.3151 2 7.00006C2 3.68506 4.685 1.00006 8 1.00006C11.315 1.00006 14 3.68506 14 7.00006C14 10.3151 11.315 13.0001 8 13.0001ZM8 11.0001C10.21 11.0001 12 9.21006 12 7.00006C12 4.79006 10.21 3.00006 8 3.00006C5.79 3.00006 4 4.79006 4 7.00006C4 9.21006 5.79 11.0001 8 11.0001ZM20.548 0.784058C21.5062 2.71589 22.0032 4.84365 22 7.00006C22 9.23306 21.477 11.3441 20.548 13.2161L18.903 12.0201C19.6282 10.446 20.0025 8.73312 20 7.00006C20 5.20806 19.607 3.50706 18.903 1.98006L20.548 0.784058ZM17.246 3.18406C17.7454 4.39422 18.0016 5.69089 18 7.00006C18.0016 8.30923 17.7454 9.6059 17.246 10.8161L15.569 9.59606C15.8552 8.76049 16.0008 7.88326 16 7.00006C16.0011 6.11691 15.8558 5.23968 15.57 4.40406L17.246 3.18406Z"
                fill="#252626"
              />
            </svg>
          </span>
          <span className="title">All Consultation </span>
        </div>
        <ChevronUp className={`chevron ${!isExpanded ? "rotate" : ""}`} />
      </button>

      {isExpanded && (
        <div className="all-sessions">
          <div className="search-container">
            <div className="search-wrapper">
              <Search className="search-icon" size={14} />
              <input
                type="text"
                value={searchQuery}
                placeholder="Search sessions..."
                className="search-input"
                onChange={(e)=>handleSearch(e.target.value)}
              />
            </div>
          </div>

          <div className="sessions-list">
            {filteredList.map((session, index) => (
              <div
                key={index}
                className={`${
                  (currentSession?.consultation_id === session.consultation_id)
                    ? "session-item-selected"
                    : "session-item"
                }`}
                onClick={() =>
                  handleSelectSession(
                    session,
                    session?.consultation_id,
                    session?.patient_name,
                    index
                  )
                }
              >
                <div className="name-container">
                  <p className="patient-name">{session.patient_name}</p>
                  <div className="circular-dot" style={{backgroundColor:`${session?.is_summary_generated ?(session?.is_final_summary_generated?" ":"#50C878"):'red'}`}}></div>
                </div>
                <div className="session-details">
                  <span className="session-time">
                    {splitDateTime(session?.created_date).date}{" "}
                    {splitDateTime(session?.created_date).time}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SessionsList;
